var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrainingPeaks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "248.000000pt",
    height: "248.000000pt",
    viewBox: "0 0 248.000000 248.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,248.000000) scale(0.100000,-0.100000)",
    fill: "#025695",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420 2464 c-185 -40 -336 -178 -393 -358 l-22 -71 0 -795 c0 -743 1 -799 18 -855 52 -168 181 -302 346 -357 66 -23 68 -23 837 -26 663 -2 782 -1 845 13 211 43 370 200 414 410 22 104 22 1526 0 1630 -44 208 -202 366 -410 410 -101 21 -1537 21 -1635 -1z m889 -821 c0 -10 -8 -47 -18 -83 l-17 -65 -147 -3 -146 -3 -12 -42 c-6 -23 -44 -170 -84 -327 l-71 -285 -141 -3 -141 -3 84 328 c46 181 84 329 84 331 0 1 -70 2 -155 2 -136 0 -155 2 -155 16 0 18 29 134 36 146 3 5 203 8 445 8 412 0 439 -1 438 -17z m691 7 c88 -14 164 -52 190 -96 29 -46 29 -130 1 -205 -61 -160 -210 -228 -507 -229 l-130 0 -28 -107 c-15 -60 -32 -125 -37 -145 l-10 -38 -138 0 -139 0 104 408 c57 224 104 410 104 415 0 11 516 8 590 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1645 1478 c-6 -18 -45 -175 -45 -182 0 -3 46 -6 103 -6 112 1 156 15 188 60 32 44 33 74 6 106 -25 28 -28 29 -136 32 -86 3 -112 1 -116 -10z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingPeaks);
export default __webpack_public_path__ + "static/media/training-peaks.8ced7abc.svg";
export { ForwardRef as ReactComponent };